export default {
  accepted: 'Aceito',
  accessRequestDate: 'Data da solicitação de acesso',
  confirmUserWillBeSystemAdmin: 'O usuário será administrador do sistema. Continuar?',
  copyInvitationLink: 'Copiar link de convite para a área de transferência',
  copyInvitationLinkConfirmMessage: `Se o usuário convidado não tiver recebido emails no endereço {{email}},
você pode copiar o link do convite para a área de transferência e compartilhá-lo por outros meios.

Copiar o link de convite para a área de transferência?`,
  copyPasswordResetLink: 'Copiar link de redefinição de senha para a área de transferência?',
  copyPasswordResetLinkConfirmMessage: `Se o usuário tiver redefinido a senha, mas não tiver recebido emails no endereço {{email}},
você pode copiar o link de redefinição de senha para a área de transferência e compartilhá-lo por outros meios.

Copiar o link de redefinição de senha para a área de transferência?`,
  editSurveyUserExtraPropsForUser: 'Editar propriedades extras do usuário no inventário para "{{userName}}"',
  inviteUser: 'Convidar',
  invitationExpiredClickToSendAgainTheInvitation: 'Convite expirado: clique para enviar o convite novamente',
  invitationLinkCopiedToClipboard: 'Link de convite copiado para a área de transferência',
  invitedBy: 'Convidado por',
  invitedDate: 'Data do convite',
  lastLogin: 'Último login',
  moreThan30DaysAgo: 'Há mais de 30 dias',
  notAcceptedYet: 'Convite ainda não aceito',
  passwordResetLinkCopiedToClipboard: 'Link de redefinição de senha copiado para a área de transferência',
  passwordResetLink: 'Link de redefinição de senha',
  prefs: {
    title: 'Preferências de notificação',
    notifyOnUserAccessRequest: 'Novas solicitações de acesso de usuários',
  },
  roleInCurrentSurvey: 'Função no inventário atual',
  roleInSurvey: 'Função no inventário',
  filterPlaceholder: 'Filtrar por nome ou email',
  surveyName: 'Nome do inventário',
  surveyExtraProp: {
    label: 'Propriedade extra do inventário',
    label_other: 'Propriedades extras do inventário',
  },
  surveysDraft: 'Inventários (rascunho)',
  surveysPublished: 'Inventários (publicados)',
  userRemovedFromSurveyGoToSurveysRequired: `Você foi removido deste inventário.  
Pressione Ir para inventários para abrir a lista de inventários.`,
  userRoleUpdatedRefreshRequired: `Sua função neste inventário foi atualizada.  
$t(common.pressRefreshToReloadPage)`,
  userGroup: {
    new: 'Novo grupo',
    edit: 'Editar grupo',
    name: 'Nome',
    label: 'Rótulo',
    qualifier: 'Qualificador {{index}}',
    qualifier_plural: 'Qualificadores',
    qualifierKey: 'Chave',
    qualifierValue: 'Valor',
    addQualifier: 'Adicionar qualificador',
    members: 'Membros',
    addMember: 'Adicionar membro',
    noMembers: 'Ainda não há membros',
    memberAlreadyInGroup: 'Atualmente em "{{groupName}}"',
    tabs: {
      groups: 'Grupos de usuários',
      assignments: 'Atribuição de grupos',
      report: 'Relatório de membros',
    },
    memberName: 'Nome do membro',
    memberEmail: 'Email do membro',
    memberRole: 'Função no inventário',
    memberStatus: 'Status',
    status: {
      INVITED: 'Convidado',
      ACCEPTED: 'Aceito',
      FORCE_CHANGE_PASSWORD: 'Troca de senha necessária',
    },
    unassigned: 'Não atribuído',
    confirmDelete: 'Excluir o grupo "{{name}}"? Seus membros ficarão não atribuídos. Continuar?',
    deleteConfirmed: 'O grupo "{{name}}" foi excluído',
    saveConfirmed: 'O grupo "{{name}}" foi salvo',
    confirmReassign: '{{userName}} está atualmente no grupo "{{groupName}}". Movê-lo para este grupo?',
    notFound: 'Grupo não encontrado',
  },
  updateUserConfirmation: 'Usuário {{name}} foi atualizado',
  userNotInvitedToAnySurvey: `Usuário não foi convidado para nenhum inventário`,
  userSurveys: 'Inventários do usuário',
}
